module.exports = "<a class=\"btn btn-primary\" (click)=\"goBack()\">Back</a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/back-button/back-button.component.html
// module id = ./src/app/shared/back-button/back-button.component.html
// module chunks = main